import { useReadersStore } from '@/store/readers.store';
import { CoinIcon } from '@/components/coins/CoinIcon';

export function CoinPouch() {
  const coinBalance = useReadersStore((s) => s.selectedCoinBalance());
  const selectedReader = useReadersStore((s) => s.selectedReader());
  const hatcheryTitle = selectedReader ? `${selectedReader.name}'s Hatchery` : 'Hatchery';

  return (
    <div>
      <p className="text-[11px] font-bold tracking-[0.12em] uppercase text-amber-700 mb-2">
        Rewards &middot; Coin Pouch
      </p>
      <h1 className="text-4xl font-display font-bold text-stone-900 mb-2">
        {hatcheryTitle}
      </h1>
      <p className="text-sm text-stone-500 max-w-[460px] mb-5 leading-relaxed">
        Earn coins by completing quizzes. Spend them on eggs that hatch into
        collectible creatures for your collection.
      </p>

      {/* Coin chip */}
      <div
        className="inline-flex items-center gap-3 rounded-2xl px-5 py-3 mb-4"
        style={{
          background: 'linear-gradient(135deg, #FFF6E2, #FCE6BC)',
          border: '1px solid #E8B679',
        }}
      >
        <CoinIcon size={42} inert />
        <div>
          <p className="text-3xl font-display font-bold text-stone-800 tabular-nums">
            {coinBalance != null ? coinBalance.toLocaleString() : '\u2014'}
          </p>
          <p className="text-[11px] text-stone-500">coins available</p>
        </div>
      </div>
    </div>
  );
}
